export const YES_SYMBOL = '〇';
export const NO_SYMBOL = 'ー';
export const PROVISION_PATTERN_BEFORE = 'before';
export const PROVISION_PATTERN_AFTER = 'after';
export const PROVISION_PATTERN_TOGETHER = 'together';
export const SERVING_TIME_FIRST_IMAGE_JA = 'pattern_before_meal.jpg';
export const SERVING_TIME_AFTER_MEAL_IMAGE_JA = 'pattern_after_meal.jpg';
export const DELETE_ALL_ERROR = 'delete_all_error';
export const defaultValues = {
  id: 0,
  name: '',
  title_ja: '',
  title_en: '',
  title_zh_hans: '',
  title_zh_hant: '',
  title_ko: '',
  title_vi: '',
  is_serving_time_first: false,
  serving_time_first_message_ja: '',
  serving_time_first_message_en: '',
  serving_time_first_message_zh_hans: '',
  serving_time_first_message_zh_hant: '',
  serving_time_first_message_ko: '',
  serving_time_first_message_vi: '',
  serving_time_first_image_ja: '',
  serving_time_first_image_en: '',
  serving_time_first_image_zh_hans: '',
  serving_time_first_image_zh_hant: '',
  serving_time_first_image_ko: '',
  serving_time_first_image_vi: '',
  is_serving_time_after_meal: false,
  serving_time_after_meal_message_ja: '',
  serving_time_after_meal_message_en: '',
  serving_time_after_meal_message_zh_hans: '',
  serving_time_after_meal_message_zh_hant: '',
  serving_time_after_meal_message_ko: '',
  serving_time_after_meal_message_vi: '',
  serving_time_after_meal_image_ja: '',
  serving_time_after_meal_image_en: '',
  serving_time_after_meal_image_zh_hans: '',
  serving_time_after_meal_image_zh_hant: '',
  serving_time_after_meal_image_ko: '',
  serving_time_after_meal_image_vi: '',
  is_serving_time_together: false,
  serving_time_together_message_ja: '',
  serving_time_together_message_en: '',
  serving_time_together_message_zh_hans: '',
  serving_time_together_message_zh_hant: '',
  serving_time_together_message_ko: '',
  serving_time_together_message_vi: '',
  serving_time_together_image_ja: '',
  serving_time_together_image_en: '',
  serving_time_together_image_zh_hans: '',
  serving_time_together_image_zh_hant: '',
  serving_time_together_image_ko: '',
  serving_time_together_image_vi: '',
  note: '',
  status: false,
  delete_flg: false,
};
